import {Button, Stack, TextField} from "@mui/material";
import {useEffect, useState} from "react";


const today = new Date().toISOString().split("T")[0];


export class DateRange {
	  constructor(from = "", to = "") {
			 this.from = from;
			 this.to = to;
	  }
}


interface APXDateRangePickerProps {
	  required?: boolean;
	  maxToday: boolean;
	  clear: boolean;
	  onDateRangeChange: (dateRange: DateRange) => void;
}


export default function APXDateRangePicker({required, maxToday, clear, onDateRangeChange}: APXDateRangePickerProps) {
	  const [dateRange, setDateRange] = useState(new DateRange());
	  
	  useEffect(() => {
			 if (onDateRangeChange) onDateRangeChange(dateRange);
	  }, [dateRange]);
	  
	  const clearDateRange = () => {
			 setDateRange(new DateRange());
	  };
	  
	  useEffect(() => {
			 if (clear) clearDateRange();
	  }, [clear]);
	  
	  
	  const startInputProps = {inputProps: {}};
	  if (maxToday) startInputProps.inputProps = {max: today};
	  else startInputProps.inputProps = {min: today};
	  
	  const endInputProps = {inputProps: {}};
	  if (maxToday) endInputProps.inputProps = {min: dateRange.from ? dateRange.from : today, max: today};
	  else endInputProps.inputProps = {min: today};
	  
	  
	  return (
				 <>
						<Stack direction={{xs: "column", sm: "row"}} spacing={2} justifyContent={"space-between"} alignItems={"center"}>
							  <TextField
										 required={required}
										 sx={{width: "100%"}}
										 type="date"
										 label="From"
										 InputLabelProps={{shrink: true}}
										 variant="outlined"
										 InputProps={startInputProps}
										 value={dateRange.from}
										 onChange={(event) => setDateRange(new DateRange(event.target.value, event.target.value))}
							  />
							  <TextField
										 required={required}
										 sx={{width: "100%"}}
										 type="date"
										 label="To"
										 InputLabelProps={{shrink: true}}
										 variant="outlined"
										 InputProps={endInputProps}
										 value={dateRange.to}
										 onChange={(event) => setDateRange(new DateRange(dateRange.from, event.target.value))}
							  />
							  <Button variant="outlined" sx={{width: "25%"}} onClick={clearDateRange}>Clear</Button>
						</Stack>
				 </>
	  );
}